import { color } from "src/styles";
import { MDiv } from "src/swsh-native";
import { AnimatedBackgroundColorViewProps } from "./types";

const AnimatedBackgroundColorView = ({
	backgroundColor = color.Background.Dark,
	children,
	style,
	duration = 500,
}: AnimatedBackgroundColorViewProps) => {
	return (
		<MDiv
			style={style}
			animate={{
				backgroundColor,
			}}
			transition={{
				type: "tween",
				duration: duration / 1000,
			}}
		>
			{children}
		</MDiv>
	);
};
export default AnimatedBackgroundColorView;
